<template>
  <div>
    <div class="text-center">
      <Button _key="btnAccept" title="Aprovar" type="success" size="medium" :clicked="update" />
    </div>
  </div>
</template>
<script>
import Button from "@nixweb/nixloc-ui/src/component/forms/Button.vue";

import { mapMutations, mapActions } from "vuex";

export default {
  name: "SupplierOrderAccept",
  props: {
    supplierOrderId: String,
  },
  components: {
    Button,
  },
  data() {
    return { urlUpdate: "/api/v1/supplier/supplier-order/accept" };
  },
  methods: {
    ...mapActions("generic", ["putApi"]),
    ...mapMutations("generic", ["addEvent", "hideModal", "removeLoading"]),
    update() {
      let params = { url: this.urlUpdate, obj: { id: this.supplierOrderId } };
      this.putApi(params).then((response) => {
        if (response.success) {
          this.addEvent({ name: "supplierOrderAccepted" });
          this.hideModal();
        }
        this.removeLoading(["btnAccept"]);
      });
    },
  },
};
</script>